/**
 * RemovableTagChip — one removable tag chip on a player card.
 *
 * Its own directory rather than a second component inside `PlayerCardTagsView`:
 * the chip needs a `useCallback` to keep its remove handler stable per tag, and
 * a component that needs a hook cannot live beside the View that renders it
 * (SE-8019).
 * @module components/organisms/custom/ui/RemovableTagChip
 */

export { default } from "./RemovableTagChipContainer";
export type { RemovableTagChipContainerProps } from "./RemovableTagChipContainer";
export type { RemovableTagChipViewProps } from "./RemovableTagChipView";
